import moment, { Moment } from 'moment';

export function isInclusivelyAfterDay(a: Moment, b: Moment): boolean {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;

  return !isBeforeDay(a, b);
}

export function isInclusivelyBeforeDay(a: Moment, b: Moment) {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
  return !isAfterDay(a, b);
}

function isAfterDay(a: Moment, b: Moment) {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
  return !isBeforeDay(a, b) && !isSameDay(a, b);
}

function isSameDay(a: Moment, b: Moment) {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
  // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow
  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
}

function isBeforeDay(a: Moment, b: Moment): boolean {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;

  const aYear: number = a.year();
  const aMonth: number = a.month();

  const bYear: number = b.year();
  const bMonth: number = b.month();

  const isSameYear: boolean = aYear === bYear;
  const isSameMonth: boolean = aMonth === bMonth;

  if (isSameYear && isSameMonth) return a.date() < b.date();

  if (isSameYear) return aMonth < bMonth;

  return aYear < bYear;
}
